import React, { useEffect, useState } from 'react';
import { apiFetch } from './api';

const EMPTY_VEHICLE = { plate: '', model: '', year: '', customer_id: '', current_km: '' };

const POPULAR_MODELS = [
  "CHEVROLET ONIX", "CHEVROLET PRISMA", "CHEVROLET CRUZE", "CHEVROLET S10", "CHEVROLET TRACKER", "CHEVROLET SPIN", "CHEVROLET MONTANA", "CHEVROLET COBALT", "CHEVROLET CELTA", "CHEVROLET CORSA", "CHEVROLET ASTRA", "CHEVROLET VECTRA",
  "VOLKSWAGEN GOL", "VOLKSWAGEN POLO", "VOLKSWAGEN T-CROSS", "VOLKSWAGEN NIVUS", "VOLKSWAGEN VIRTUS", "VOLKSWAGEN AMAROK", "VOLKSWAGEN VOYAGE", "VOLKSWAGEN SAVEIRO", "VOLKSWAGEN FOX", "VOLKSWAGEN JETTA", "VOLKSWAGEN TIGUAN", "VOLKSWAGEN GOLF", "VOLKSWAGEN UP!",
  "FIAT STRADA", "FIAT TORO", "FIAT ARGO", "FIAT MOBI", "FIAT CRONOS", "FIAT PULSE", "FIAT FASTBACK", "FIAT UNO", "FIAT PALIO", "FIAT SIENA", "FIAT FIORINO", "FIAT DUCATO", "FIAT PUNTO", "FIAT LINEA", "FIAT BRAVO",
  "FORD KA", "FORD RANGER", "FORD ECOSPORT", "FORD FIESTA", "FORD FOCUS", "FORD FUSION", "FORD TERRITORY", "FORD MAVERICK", "FORD BRONCO",
  "HYUNDAI HB20", "HYUNDAI HB20S", "HYUNDAI CRETA", "HYUNDAI TUCSON", "HYUNDAI IX35", "HYUNDAI SANTA FE", "HYUNDAI AZERA", "HYUNDAI HR",
  "TOYOTA COROLLA", "TOYOTA HILUX", "TOYOTA YARIS", "TOYOTA COROLLA CROSS", "TOYOTA SW4", "TOYOTA ETIOS", "TOYOTA RAV4", "TOYOTA CAMRY",
  "HONDA CIVIC", "HONDA FIT", "HONDA HR-V", "HONDA CITY", "HONDA WR-V", "HONDA CR-V", "HONDA ACCORD",
  "JEEP COMPASS", "JEEP RENEGADE", "JEEP COMMANDER", "JEEP CHEROKEE", "JEEP WRANGLER",
  "NISSAN KICKS", "NISSAN FRONTIER", "NISSAN VERSA", "NISSAN MARCH", "NISSAN SENTRA", "NISSAN TIIDA",
  "RENAULT KWID", "RENAULT SANDERO", "RENAULT DUSTER", "RENAULT LOGAN", "RENAULT OROCH", "RENAULT MASTER", "RENAULT CAPTUR", "RENAULT CLIO",
  "PEUGEOT 208", "PEUGEOT 2008", "PEUGEOT 3008", "PEUGEOT PARTNER", "PEUGEOT EXPERT", "PEUGEOT 308", "PEUGEOT 408",
  "CITROEN C3", "CITROEN C4 CACTUS", "CITROEN C3 AIRCROSS", "CITROEN JUMPY", "CITROEN BERLINGO", "CITROEN C4 PALLAS",
  "MITSUBISHI L200", "MITSUBISHI ASX", "MITSUBISHI OUTLANDER", "MITSUBISHI PAJERO", "MITSUBISHI ECLIPSE CROSS",
  "CAOA CHERY TIGGO 5X", "CAOA CHERY TIGGO 7", "CAOA CHERY TIGGO 8", "CAOA CHERY ARRIZO 6", "CAOA CHERY iCAR",
  "BYD DOLPHIN", "BYD SEAL", "BYD SONG PLUS", "BYD YUAN PLUS", "BYD TAN",
  "GWM HAVAL H6", "GWM ORA 03",
  "BMW 320i", "BMW X1", "BMW X3", "BMW X5", "BMW 118i",
  "MERCEDES-BENZ CLASSE C", "MERCEDES-BENZ GLA", "MERCEDES-BENZ GLC", "MERCEDES-BENZ SPRINTER",
  "AUDI A3", "AUDI Q3", "AUDI A4", "AUDI Q5",
  "VOLVO XC40", "VOLVO XC60", "VOLVO XC90",
  "KIA SPORTAGE", "KIA CERATO", "KIA BONGO", "KIA STONIC",
  "HONDA CG 160", "HONDA BIZ 125", "HONDA NXR 160 BROS", "HONDA PCX", "HONDA CB 300F", "HONDA XRE 300", "HONDA CB 500", "HONDA CRF 250",
  "YAMAHA FACTOR 150", "YAMAHA FAZER 250", "YAMAHA MT-03", "YAMAHA XMAX", "YAMAHA NMAX", "YAMAHA LANDER 250", "YAMAHA CROSSER 150"
];

// ── Lógica de alertas baseada no ano do veículo ───────────────────────────
function getAlertStatus(year) {
  if (!year) return 'warn';
  const age = new Date().getFullYear() - year;
  if (age <= 5)  return 'ok';
  if (age <= 10) return 'warn';
  return 'danger';
}

function getAlertInfo(year) {
  if (!year) return { cls: 'warn',   icon: 'fa-question-circle',     text: 'Ano não informado' };
  const age = new Date().getFullYear() - year;
  if (age <= 5)  return { cls: 'ok',     icon: 'fa-check-circle',        text: 'Veículo Recente' };
  if (age <= 10) return { cls: 'warn',   icon: 'fa-exclamation-triangle', text: `Atenção: ${age} anos de uso` };
  return           { cls: 'danger', icon: 'fa-times-circle',          text: `Revisão Recomendada (${age} anos)` };
}

// ── Ícone contextual por tipo de veículo ─────────────────────────────────
function getCarIcon(model) {
  if (!model) return '🚗';
  const m = model.toLowerCase();
  if (m.includes('moto') || m.includes('cg') || m.includes('yamaha') || m.includes('fan')) return '🏍️';
  if (m.includes('caminhão') || m.includes('caminhao') || m.includes('truck')) return '🚛';
  if (m.includes('van') || m.includes('furgão') || m.includes('furgao') || m.includes('sprinter')) return '🚐';
  if (m.includes('pickup') || m.includes('hilux') || m.includes('ranger') || m.includes('s10') || m.includes('l200')) return '🛻';
  if (m.includes('suv') || m.includes('tucson') || m.includes('compass') || m.includes('creta')) return '🚙';
  return '🚗';
}

function Vehicles({ tenantId }) {
  const [vehicles,  setVehicles]  = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [search,    setSearch]    = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  // painel deslizante
  const [selected, setSelected] = useState(null);

  // modal novo veículo
  const [showModal,  setShowModal]  = useState(false);
  const [newVehicle, setNewVehicle] = useState(EMPTY_VEHICLE);

  // modal IA
  const [aiModal,   setAiModal]   = useState(null);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiResult,  setAiResult]  = useState(null);
  const [aiError,   setAiError]   = useState(null);

  // ── Fetch ─────────────────────────────────────────────────────────────
  const fetchAll = () => {
    setLoading(true);
    Promise.all([
      apiFetch(`/vehicles?tenant_id=${tenantId}`).then(r => r.json()),
      apiFetch(`/customers?tenant_id=${tenantId}`).then(r => r.json()),
    ]).then(([vData, cData]) => {
      setVehicles(vData.vehicles || []);
      setCustomers(cData.customers || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  useEffect(() => { fetchAll(); }, [tenantId]); // eslint-disable-line

  // Travar o scroll do body quando o painel ou modais estão abertos
  useEffect(() => {
    if (selected || showModal || aiModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => { document.body.style.overflow = 'unset'; };
  }, [selected, showModal, aiModal]);

  const getCustomerName = (customerId) => {
    const c = customers.find(c => c[0] === customerId);
    return c ? c[1] : `#${customerId}`;
  };

  // ── Criar veículo ──────────────────────────────────────────────────────
  const handleCreate = async (e) => {
    e.preventDefault();
    if (!newVehicle.customer_id) { alert('Por favor, selecione um cliente.'); return; }
    const res = await apiFetch(`/vehicles?tenant_id=${tenantId}`, {
      method: 'POST',
      body: JSON.stringify({
        ...newVehicle,
        year: newVehicle.year ? parseInt(newVehicle.year) : null,
        current_km: newVehicle.current_km ? parseInt(newVehicle.current_km) : null,
        customer_id: parseInt(newVehicle.customer_id),
      }),
    });
    if (res.ok) {
      setShowModal(false);
      setNewVehicle(EMPTY_VEHICLE);
      fetchAll();
    } else {
      alert('Erro ao cadastrar veículo.');
    }
  };

  // ── IA: Consultar Manual ──────────────────────────────────────────────
  const openAiModal = async (vehicle) => {
    setAiModal(vehicle);
    setAiLoading(true);
    setAiResult(null);
    setAiError(null);
    try {
      const res = await apiFetch(`/api/vehicles/diagnose?tenant_id=${tenantId}`, {
        method: 'POST',
        body: JSON.stringify({
          vehicle_id: vehicle[0],
          plate: vehicle[1],
          model: vehicle[2],
          year: vehicle[3],
          current_km: vehicle[5] || null,
        }),
      });
      if (res.ok) {
        setAiResult(await res.json());
      } else {
        setAiError('O servidor retornou um erro. A rota de IA pode ainda estar em implementação.');
      }
    } catch {
      setAiError('Erro de conexão. Verifique se o backend está ativo.');
    } finally {
      setAiLoading(false);
    }
  };

  // ── Filtro ─────────────────────────────────────────────────────────────
  const filtered = vehicles.filter(vh => {
    let matchSearch = true;
    if (search) {
      const s = search.toLowerCase();
      matchSearch = (
        (vh[1] || '').toLowerCase().includes(s) ||
        (vh[2] || '').toLowerCase().includes(s) ||
        getCustomerName(vh[4]).toLowerCase().includes(s)
      );
    }
    
    let matchStatus = true;
    if (filterStatus !== 'all') {
      matchStatus = getAlertStatus(vh[3]) === filterStatus;
    }

    return matchSearch && matchStatus;
  });

  if (loading) return <div className="stat-label" style={{ padding: '3rem', textAlign: 'center' }}>Carregando frota...</div>;

  const selAlert    = selected ? getAlertInfo(selected[3]) : null;
  const selCustomer = selected ? getCustomerName(selected[4]) : '';

  return (
    <div className="animate-fade">

      {/* ── Cabeçalho ── */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '700' }}>Frota</h2>
          <p style={{ color: 'var(--gray)', fontSize: '0.875rem' }}>
            {vehicles.length} veículo{vehicles.length !== 1 ? 's' : ''} cadastrado{vehicles.length !== 1 ? 's' : ''}
          </p>
        </div>
        <button
          className="btn-primary"
          style={{ padding: '0.75rem 1.25rem', borderRadius: '10px' }}
          onClick={() => setShowModal(true)}
        >
          <i className="fas fa-plus" style={{ marginRight: '8px' }}></i> Novo Veículo
        </button>
      </div>

      {/* ── Stats ── */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem', marginBottom: '2rem' }}>
        {[
          { id: 'all', count: vehicles.length, icon: 'fa-car-side', bg: 'rgb(14 165 233 / 0.1)', color: 'var(--primary)', label: 'Total' },
          { id: 'ok', count: vehicles.filter(v => getAlertStatus(v[3]) === 'ok').length, icon: 'fa-calendar-check', bg: 'rgb(16 185 129 / 0.1)', color: 'var(--success)', label: 'Recentes (≤5 anos)' },
          { id: 'danger', count: vehicles.filter(v => getAlertStatus(v[3]) === 'danger').length, icon: 'fa-exclamation-triangle', bg: 'rgb(239 68 68 / 0.1)', color: 'var(--danger)', label: 'Precisam Atenção' },
        ].map((s, i) => (
          <div key={i} onClick={() => setFilterStatus(filterStatus === s.id ? 'all' : s.id)} style={{ cursor: 'pointer', background: filterStatus === s.id ? s.bg : 'var(--white)', padding: '1.25rem', borderRadius: '16px', border: filterStatus === s.id ? `2px solid ${s.color}` : '2px solid transparent', boxShadow: 'var(--shadow)', display: 'flex', alignItems: 'center', gap: '0.75rem', transition: 'all 0.2s' }}>
            <div style={{ width: '45px', height: '45px', borderRadius: '12px', background: filterStatus === s.id ? s.color : s.bg, color: filterStatus === s.id ? 'white' : s.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', flexShrink: 0, transition: 'all 0.2s' }}>
              <i className={`fas ${s.icon}`}></i>
            </div>
            <div>
              <div style={{ fontSize: '1.5rem', fontWeight: '700' }}>{s.count}</div>
              <div style={{ fontSize: '0.8rem', color: filterStatus === s.id ? 'var(--text-main)' : 'var(--gray)' }}>{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* ── Busca ── */}
      <div style={{ marginBottom: '1.5rem', position: 'relative' }}>
        <i className="fas fa-search" style={{ position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray)', pointerEvents: 'none' }}></i>
        <input
          type="text"
          placeholder="Buscar por placa, modelo ou proprietário..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: '100%', padding: '0.625rem 1rem 0.625rem 2.5rem', border: '2px solid #e2e8f0', borderRadius: '10px', fontSize: '0.875rem', boxSizing: 'border-box' }}
        />
      </div>

      {/* ── Grade de veículos ── */}
      {filtered.length === 0 ? (
        <div style={{ padding: '4rem', textAlign: 'center', color: 'var(--gray)' }}>
          <i className="fas fa-car" style={{ fontSize: '2.5rem', marginBottom: '1rem', display: 'block', opacity: 0.4 }}></i>
          {search ? 'Nenhum veículo encontrado para esta busca.' : 'Nenhum veículo cadastrado.'}
        </div>
      ) : (
        <div className="vehicle-grid">
          {filtered.map(vh => {
            const alert = getAlertInfo(vh[3]);
            const age   = vh[3] ? new Date().getFullYear() - vh[3] : null;
            return (
              <div
                key={vh[0]}
                onClick={() => setSelected(vh)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.875rem',
                  background: 'var(--bg-card)',
                  border: '1px solid var(--border)',
                  borderRadius: '14px',
                  padding: '0.875rem 1rem',
                  cursor: 'pointer',
                  transition: 'all 0.18s cubic-bezier(0.4,0,0.2,1)',
                  boxShadow: 'var(--shadow-sm)',
                  position: 'relative',
                  overflow: 'hidden',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = 'var(--shadow)';
                  e.currentTarget.style.borderColor = 'rgba(37,99,235,0.3)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = '';
                  e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
                  e.currentTarget.style.borderColor = 'var(--border)';
                }}
              >
                {/* Barra de status lateral */}
                <div style={{
                  position: 'absolute', left: 0, top: 0, bottom: 0, width: '3px',
                  borderRadius: '14px 0 0 14px',
                  background: alert.cls === 'ok' ? 'var(--success)' : alert.cls === 'warn' ? 'var(--warning)' : 'var(--danger)',
                }} />

                {/* Placa */}
                <div style={{
                  background: '#fbbf24',
                  color: '#1a1a1a',
                  fontWeight: '800',
                  fontSize: '0.8rem',
                  letterSpacing: '1.5px',
                  padding: '0.35rem 0.6rem',
                  borderRadius: '6px',
                  whiteSpace: 'nowrap',
                  minWidth: '72px',
                  textAlign: 'center',
                  boxShadow: '0 2px 6px rgba(251,191,36,0.3)',
                  flexShrink: 0,
                }}>
                  {vh[1] || '???'}
                </div>

                {/* Modelo + dono */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: '700', fontSize: '0.92rem', color: 'var(--text-primary)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {vh[2] || 'Modelo não informado'}
                  </div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '1px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <i className="fas fa-user" style={{ marginRight: '4px', color: 'var(--primary)', fontSize: '0.7rem' }}></i>
                    {getCustomerName(vh[4])}
                  </div>
                </div>

                {/* Stats inline */}
                <div style={{ display: 'flex', gap: '0.5rem', flexShrink: 0 }}>
                  {[{val: vh[3] || '-', lbl: 'Ano'}, {val: age ? `${age}a` : '-', lbl: 'Idade'}, {val: vh[5] ? Number(vh[5]).toLocaleString('pt-BR') : '-', lbl: 'KM'}].map(s => (
                    <div key={s.lbl} style={{ textAlign: 'center', background: 'var(--bg-surface)', borderRadius: '8px', padding: '0.3rem 0.5rem', minWidth: '46px' }}>
                      <div style={{ fontWeight: '700', fontSize: '0.8rem', color: 'var(--text-primary)', lineHeight: 1.2 }}>{s.val}</div>
                      <div style={{ fontSize: '0.6rem', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{s.lbl}</div>
                    </div>
                  ))}
                </div>

                {/* Seta */}
                <i className="fas fa-chevron-right" style={{ color: 'var(--text-secondary)', fontSize: '0.75rem', flexShrink: 0, opacity: 0.5 }}></i>
              </div>
            );
          })}
        </div>
      )}

      {/* ── Overlay backdrop ── */}
      <div className={`overlay-backdrop ${selected ? 'active' : ''}`} onClick={() => setSelected(null)}></div>

      {/* ── Painel deslizante ── */}
      <div className={`detail-panel ${selected ? 'open' : ''}`}>
        {selected && (
          <>
            <div className="detail-header" style={{ background: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
              <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '1.1rem' }}>
                <span style={{ fontSize: '1.75rem' }}>{getCarIcon(selected[2])}</span>
                Detalhes do Veículo
              </h3>
              <button
                onClick={() => setSelected(null)}
                style={{ background: 'none', border: 'none', fontSize: '1.4rem', cursor: 'pointer', color: 'var(--gray)', lineHeight: 1 }}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="detail-body">

              {/* Banner da placa */}
              <div style={{ background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)', borderRadius: '16px', padding: '2rem', marginBottom: '1.5rem', textAlign: 'center' }}>
                <div style={{ fontSize: '4rem', marginBottom: '0.75rem', filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.4))' }}>
                  {getCarIcon(selected[2])}
                </div>
                <div style={{ display: 'inline-block', background: '#ffeb3b', color: '#1a1a1a', padding: '0.5rem 1.75rem', borderRadius: '8px', fontWeight: '800', fontSize: '1.4rem', letterSpacing: '4px', boxShadow: '0 4px 12px rgba(0,0,0,0.3)' }}>
                  {selected[1] || '???'}
                </div>
              </div>

              {/* Alerta de status */}
              <div className={`vehicle-alert ${selAlert.cls}`}>
                <i className={`fas ${selAlert.icon}`}></i>
                {selAlert.text}
              </div>

              {/* Botão IA (Movido para cima) */}
              <button
                onClick={() => openAiModal(selected)}
                style={{ marginBottom: '1.5rem', width: '100%', padding: '0.875rem', borderRadius: '12px', border: '2px solid #7c3aed', background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', color: 'white', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', boxShadow: '0 4px 12px rgba(124,58,237,0.3)' }}
              >
                ✨ Consultar Manual Inteligente
              </button>

              {/* Especificações */}
              <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '1.25rem', marginBottom: '1.5rem' }}>
                <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: 'var(--gray)', letterSpacing: '0.08em', marginBottom: '1rem', fontWeight: '600' }}>
                  Especificações
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem' }}>
                  <div>
                    <div style={{ fontSize: '0.7rem', color: 'var(--gray)', textTransform: 'uppercase', marginBottom: '0.2rem' }}>Modelo / Marca</div>
                    <strong>{selected[2] || 'Não informado'}</strong>
                  </div>
                  <div>
                    <div style={{ fontSize: '0.7rem', color: 'var(--gray)', textTransform: 'uppercase', marginBottom: '0.2rem' }}>Ano de Fabricação</div>
                    <strong>{selected[3] || 'Não informado'}</strong>
                  </div>
                  <div>
                    <div style={{ fontSize: '0.7rem', color: 'var(--gray)', textTransform: 'uppercase', marginBottom: '0.2rem' }}>Idade do Veículo</div>
                    <strong>{selected[3] ? `${new Date().getFullYear() - selected[3]} anos` : '-'}</strong>
                  </div>
                  <div>
                    <div style={{ fontSize: '0.7rem', color: 'var(--gray)', textTransform: 'uppercase', marginBottom: '0.2rem' }}>Quilometragem Atual</div>
                    <strong>{selected[5] ? `${Number(selected[5]).toLocaleString('pt-BR')} km` : 'Não informado'}</strong>
                  </div>
                  <div style={{ gridColumn: '1 / -1' }}>
                    <div style={{ fontSize: '0.7rem', color: 'var(--gray)', textTransform: 'uppercase', marginBottom: '0.2rem' }}>Proprietário</div>
                    <strong>
                      <i className="fas fa-user" style={{ marginRight: '6px', color: 'var(--primary)' }}></i>
                      {selCustomer}
                    </strong>
                  </div>
                </div>
              </div>

              {/* Histórico placeholder */}
              <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '1.25rem' }}>
                <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: 'var(--gray)', letterSpacing: '0.08em', marginBottom: '1rem', fontWeight: '600' }}>
                  Histórico de Manutenção
                </div>
                <div style={{ textAlign: 'center', padding: '1.5rem 1rem', color: 'var(--gray)', fontSize: '0.875rem' }}>
                  <i className="fas fa-wrench" style={{ fontSize: '1.5rem', marginBottom: '0.75rem', display: 'block', opacity: 0.5 }}></i>
                  Histórico vinculado ao agendamento de serviços
                </div>
              </div>

            </div>
          </>
        )}
      </div>

      {/* ── Modal IA: Manual Inteligente ── */}
      {aiModal && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', background: 'rgba(15,23,42,0.82)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)' }}>
          <div className="ai-glass" style={{ width: '100%', maxWidth: '660px', maxHeight: '88vh', display: 'flex', flexDirection: 'column', color: 'white', overflow: 'hidden' }}>

            {/* Cabeçalho */}
            <div style={{ padding: '1.5rem 1.75rem', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.875rem' }}>
                <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: 'linear-gradient(135deg,#7c3aed,#a78bfa)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.3rem', flexShrink: 0 }}>✨</div>
                <div>
                  <h3 style={{ margin: 0, fontSize: '1.05rem', fontWeight: '700' }}>Manual Inteligente</h3>
                  <p style={{ margin: 0, fontSize: '0.8rem', color: 'rgba(255,255,255,0.55)' }}>
                    {aiModal[2]} {aiModal[3] || ''}{aiModal[5] ? ` · ${Number(aiModal[5]).toLocaleString('pt-BR')} km` : ''}
                  </p>
                </div>
              </div>
              <button
                onClick={() => { setAiModal(null); setAiResult(null); setAiError(null); }}
                style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.8)', width: '36px', height: '36px', borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.9rem', flexShrink: 0 }}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            {/* Corpo */}
            <div style={{ padding: '2rem 1.75rem', overflowY: 'auto', flex: 1 }}>

              {/* Loading */}
              {aiLoading && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.5rem', padding: '2.5rem 0' }}>
                  <div className="ai-spinner"></div>
                  <div style={{ textAlign: 'center' }}>
                    <p style={{ fontWeight: '600', fontSize: '1rem', margin: '0 0 0.35rem' }}>A IA está analisando os manuais da montadora...</p>
                    <p style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.5)', margin: 0 }}>Consultando base técnica para {aiModal[2]}</p>
                  </div>
                  <div style={{ display: 'flex', gap: '7px' }}>
                    {[0, 1, 2].map(i => (
                      <div key={i} className="ai-dot" style={{ animationDelay: `${i * 0.22}s` }}></div>
                    ))}
                  </div>
                </div>
              )}

              {/* Erro */}
              {!aiLoading && aiError && (
                <div style={{ textAlign: 'center', padding: '2.5rem 0' }}>
                  <i className="fas fa-exclamation-circle" style={{ fontSize: '2.25rem', color: '#fbbf24', display: 'block', marginBottom: '1rem' }}></i>
                  <p style={{ fontWeight: '600', marginBottom: '0.5rem' }}>Não foi possível consultar a IA</p>
                  <p style={{ fontSize: '0.83rem', color: 'rgba(255,255,255,0.5)', marginBottom: '1.75rem' }}>{aiError}</p>
                  <button
                    onClick={() => openAiModal(aiModal)}
                    style={{ padding: '0.625rem 1.5rem', borderRadius: '10px', background: 'rgba(124,58,237,0.7)', border: '1px solid rgba(124,58,237,0.9)', color: 'white', cursor: 'pointer', fontWeight: '600', fontSize: '0.875rem' }}
                  >
                    <i className="fas fa-redo" style={{ marginRight: '6px' }}></i> Tentar novamente
                  </button>
                </div>
              )}

              {/* Resultado */}
              {!aiLoading && aiResult && (() => {
                const raw = aiResult.diagnostico || aiResult.response || aiResult.message || aiResult.result || JSON.stringify(aiResult, null, 2);
                const lines = String(raw).split('\n').filter(l => l.trim());
                return (
                  <div>
                    {lines.map((line, i) => {
                      const trimmed = line.trim();
                      const isBullet = /^[-•*] /.test(trimmed);
                      const isHeader = /^#{1,3} /.test(trimmed) || (trimmed === trimmed.toUpperCase() && trimmed.length > 6 && trimmed.length < 60);
                      const text = trimmed.replace(/^[-•*#]+ ?/, '').replace(/\*\*(.*?)\*\*/g, '$1').trim();
                      return (
                        <div key={i} className="ai-result-line" style={{ fontWeight: isHeader ? '700' : 'normal', color: isHeader ? 'white' : 'rgba(255,255,255,0.88)', marginBottom: isHeader ? '0.9rem' : '0.5rem', marginTop: isHeader && i > 0 ? '1rem' : 0 }}>
                          {isBullet && <span style={{ color: '#4ade80', flexShrink: 0, marginTop: '2px', fontSize: '0.85rem' }}>✓</span>}
                          <span style={{ width: '100%' }}>{text || trimmed}</span>
                        </div>
                      );
                    })}
                    <button
                      onClick={() => { setAiModal(null); setAiResult(null); }}
                      style={{ marginTop: '1.75rem', width: '100%', padding: '0.75rem', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.08)', color: 'white', fontWeight: '600', cursor: 'pointer', fontSize: '0.875rem' }}
                    >
                      Fechar
                    </button>
                  </div>
                );
              })()}

            </div>
          </div>
        </div>
      )}

      {/* ── Modal: Novo Veículo ── */}
      {showModal && (
        <div className="modal-overlay active" style={{ zIndex: 200 }}>
          <div className="modal-container" style={{ maxWidth: '480px', width: '90%' }}>
            <div className="modal-header">
              <h3>Novo Veículo</h3>
              <p className="stat-label">Vincule um automóvel à sua base de clientes</p>
            </div>
            <form onSubmit={handleCreate} style={{ padding: '1.5rem' }}>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', fontWeight: '600', fontSize: '0.875rem', marginBottom: '0.5rem' }}>Placa do Veículo</label>
                <input
                  type="text" required
                  value={newVehicle.plate}
                  onChange={e => setNewVehicle({ ...newVehicle, plate: e.target.value.toUpperCase() })}
                  placeholder="ABC1D23"
                  style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px', letterSpacing: '3px', fontWeight: '700', boxSizing: 'border-box' }}
                />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                <div>
                  <label style={{ display: 'block', fontWeight: '600', fontSize: '0.875rem', marginBottom: '0.5rem' }}>Modelo / Marca</label>
                  <input
                    type="text" required
                    list="car-models-list"
                    value={newVehicle.model}
                    onChange={e => setNewVehicle({ ...newVehicle, model: e.target.value.toUpperCase() })}
                    placeholder="Ex: HONDA CIVIC"
                    style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px', boxSizing: 'border-box' }}
                  />
                  <datalist id="car-models-list">
                    {POPULAR_MODELS.map(m => <option key={m} value={m} />)}
                  </datalist>
                </div>
                <div>
                  <label style={{ display: 'block', fontWeight: '600', fontSize: '0.875rem', marginBottom: '0.5rem' }}>Ano</label>
                  <input
                    type="number"
                    value={newVehicle.year}
                    onChange={e => setNewVehicle({ ...newVehicle, year: e.target.value })}
                    placeholder="2024"
                    style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px', boxSizing: 'border-box' }}
                  />
                </div>
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', fontWeight: '600', fontSize: '0.875rem', marginBottom: '0.5rem' }}>
                  <i className="fas fa-tachometer-alt" style={{ marginRight: '6px', color: 'var(--primary)' }}></i>
                  Quilometragem Atual (KM)
                </label>
                <input
                  type="number"
                  value={newVehicle.current_km}
                  onChange={e => setNewVehicle({ ...newVehicle, current_km: e.target.value })}
                  placeholder="Ex: 45000"
                  style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px', boxSizing: 'border-box' }}
                />
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', fontWeight: '600', fontSize: '0.875rem', marginBottom: '0.5rem' }}>Proprietário</label>
                <select
                  required
                  value={newVehicle.customer_id}
                  onChange={e => setNewVehicle({ ...newVehicle, customer_id: e.target.value })}
                  style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px', background: 'white', boxSizing: 'border-box' }}
                >
                  <option value="">Selecione um cliente...</option>
                  {customers.map(c => (
                    <option key={c[0]} value={c[0]}>{c[1]} (#{c[0]})</option>
                  ))}
                </select>
              </div>

              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  onClick={() => { setShowModal(false); setNewVehicle(EMPTY_VEHICLE); }}
                  style={{ padding: '0.625rem 1.25rem', borderRadius: '10px', border: '2px solid #e2e8f0', background: 'white', cursor: 'pointer', fontWeight: '600' }}
                >
                  Cancelar
                </button>
                <button type="submit" className="btn-primary" style={{ padding: '0.625rem 1.25rem', borderRadius: '10px' }}>
                  Vincular Veículo
                </button>
              </div>

            </form>
          </div>
        </div>
      )}

    </div>
  );
}

export default Vehicles;
